import { createSlice } from '@reduxjs/toolkit';
import {
  acceptClientRequestBuilder,
  createClientPaymentBuilder,
  deleteClientPaymentBuilder,
  editPaymentPlanForClientBuilder,
  getClientPaymentBuilder,
  rejectPaymentForClientBuilder,
} from './builder';
import { createPaymentsForClientBuilder } from './builder';

const initialState = {
  createPaymentsClientPending: false,
  getClientPaymentPending: false,
  acceptClientRequestPaymentPending: false,
  rejectClientRequestPaymentPending: false,
  createClientPaymentPending: false,
  editPaymentPlanForClientPending: false,
  deleteClientPaymentPending: false,

  clientPayments: {
    data: [],
    notPaidInstallments: [],
    totalPaidAmount: 0,
    remainingAmount: 0,
    totalAmountVendor: 0,
  },
};
export const paymentsSlice = createSlice({
  name: 'paymentInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    createPaymentsForClientBuilder(builder);
    getClientPaymentBuilder(builder);
    acceptClientRequestBuilder(builder);
    rejectPaymentForClientBuilder(builder);
    createClientPaymentBuilder(builder);
    editPaymentPlanForClientBuilder(builder);
    deleteClientPaymentBuilder(builder);

    builder.addCase('logout', () => initialState);
  },
});

export const selectClientPayments = state => state.paymentInfo.clientPayments;
export const selectCreatePaymentsClientPending = state => state.paymentInfo.createPaymentsClientPending;
export const selectGetClientPaymentPending = state => state.paymentInfo.getClientPaymentPending;
export const selectAcceptClientRequestPaymentPending = state => state.paymentInfo.acceptClientRequestPaymentPending;
export const selectRejectClientRequestPaymentPending = state => state.paymentInfo.rejectClientRequestPaymentPending;
export const selectCreateClientPaymentPending = state => state.paymentInfo.createClientPaymentPending;
export const selectEditPaymentPlanForClientPending = state => state.paymentInfo.editPaymentPlanForClientPending;
export const selectDeleteClientPaymentPending = state => state.paymentInfo.deleteClientPaymentPending;

export const { resetSelectedTemplate } = paymentsSlice.actions;

export default paymentsSlice.reducer;
